<template>
  <!-- <div class="grid-12" v-if="eventList.length">
      <ui-heading tag="h4" bullet bold>{{$t('activeEventList')}} <small><router-link to="/event">{{$t('allEvents')}}</router-link></small></ui-heading>
    </div> -->
  <!--     <div class="grid-12" v-if="eventList.length">
      <event-list></event-list>
    </div> -->
  <div>
    <ui-row>
      <ui-col>
        <ui-heading tag="h4" class="page-title" bold
          >{{ $t("book")
          }}<ui-checkbox size="sm" v-model="showPrivate" toggle>{{
            $t("privateBook")
          }}</ui-checkbox>
        </ui-heading>
      </ui-col>
    </ui-row>
    <book-list type="public" :is-private="showPrivate"></book-list>
  </div>
</template>
<script>
import BookList from "../components/book/BookList.vue";
// import EventList from "../components/event/EventList.vue";
export default {
  data() {
    return {
      showPrivate: false
    };
  },
  components: {
    BookList
    // EventList
  }
};
</script>
<style lang="scss" scoped>
.page-title {
  justify-content: space-between;
}
</style>
